module.exports.Captcha = require('./dist/reactjs-captcha');
module.exports.captchaSettings = require('./dist/captcha-settings');


//////////////////
// WEBPACK FOOTER
// ./node_modules/reactjs-captcha/index.js
// module id = 142
// module chunks = 4